import { X } from 'lucide-react';

export function IngredientPopup({ ingredient, position, onClose }) {
  if (!ingredient || !position) return null;

  // Calculate position to keep popover on screen
  const popoverStyle = {
    position: 'fixed',
    left: `${Math.min(position.x, window.innerWidth - 280)}px`,
    top: `${position.y + 10}px`,
    maxWidth: '260px',
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 z-40"
        onClick={onClose}
      />
      
      {/* Popover */}
      <div 
        style={popoverStyle}
        className="bg-white rounded-2xl shadow-2xl p-4 z-50 border border-gray-100 relative"
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 w-8 h-8 rounded-full flex items-center justify-center text-muted-foreground hover:bg-gray-100 transition-colors"
          aria-label="Close ingredient details"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="space-y-2">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Quantity</p>
            <p className="text-lg" style={{ color: '#667D3F' }}>{ingredient.quantity}</p>
          </div>
          <div className="border-t border-gray-100 pt-2">
            <p className="text-xs text-muted-foreground mb-1">Ingredient</p>
            <p className="text-sm text-gray-900">{ingredient.name}</p>
          </div>
        </div>
      </div>
    </>
  );
}
